import Vue from 'vue';
import { getSwiper, getSwiperModules } from '../utils';

Vue.component('aftersales-services-carousel', {
    data() {
        return {
            tabIndex: 0,
            sectionIndex: 0,
        };
    },

    async mounted() {
        await this.initSwiper();
    },

    methods: {
        switchSection(index) {
            if (index != this.tabIndex) {
                this.tabIndex = index;
                this.sectionIndex = index;

                setTimeout(() => this.initSwiper(), 100);
            }
        },

        async initSwiper() {
            const { Swiper } = await getSwiper();
            const { Scrollbar, Navigation } = await getSwiperModules();
            const isMobile = window.innerWidth < 768;

            new Swiper('.aftersales-services-carousel__slider', {
                slidesPerView: isMobile ? 1.2 : 3.1,
                spaceBetween: isMobile ? 20 : 32,
                loop: false,
                observer: true,
                observeParents: true,
                centeredSlides: false,
                modules: [Scrollbar, Navigation],
                pagination: {},
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false,
                    draggable: true,
                },
                uniqueNavElements: true,
                navigation: {
                    nextEl: '.aftersales__carousel-button--next',
                    prevEl: '.aftersales__carousel-button--prev',
                },
            });
        },
    },
});
